import axios from "axios";
import { toast } from "react-toastify";
import { API_path } from "./apiPath";

const apiBaseURL = process.env.REACT_APP_API_URL;
const lsUserVO = process.env.REACT_APP_LS_USER_VO;
const axiosInstance = axios.create({
  baseURL: apiBaseURL,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
  },
});
// Request interceptor
const pimsUserVO =JSON.parse(localStorage.getItem(lsUserVO));
axiosInstance.interceptors.request.use(
  (config) => {
    if (config.url !== API_path.login) {
      // console.log(pimsUserVO);
      const token = pimsUserVO.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);
// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Do something with successful response
    console.log(response);
    return response;
  },
  (error) => {
    // Do something with response error
    console.log("ERROR :",error);
    if (error && error.response && error.response.data) {
      console.log(error.response.data);
      const errorResponse = error.response.data;
      toast.error(
        `Status code : ${errorResponse.status} error : ${errorResponse.title}`
      );
    } else {
      console.log("ERROR :",error.message);
      toast.error(error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
